export default "__VITE_ASSET__DMTsOABf__"